import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Section from './Section';
import FirstPage from '../../pages/FirstPage';
import SecondPage from '../../pages/SecondPage';
import ThirdPage from '../../pages/ThirdPage';
import FourthPage from '../../pages/FourthPage';

const MainSection = () => {
  const location = useLocation();

  return (
    <Section
      minWidth={location.pathname === '/fourth' ? '1222px' : '810px'}
      padding="40px 16px 0px 16px"
    >
      <Routes>
        <Route path="/" element={<FirstPage />} />
        <Route path="/second" element={<SecondPage />} />
        <Route path="/third" element={<ThirdPage />} />
        <Route path="/fourth" element={<FourthPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Section>
  );
};

export default MainSection;
